import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { DckActionCreators, DckSelectors } from "dck-redux"

import * as ItemTypes from "../../../redux/items/types"
import ProcessTypes from "../../../redux/processes/types"
import UserForm from "../UserForm"

class AddUser extends Component {

  componentDidMount() {
    this.props.loadUserRoles()
  }
  
  render() {
    return (
      <div>

        <UserForm
          user={null}
          onSaveClicked={data => this.props.addUser(data)}
          userRoles={ this.props.userRoles }
          locales={ this.props.userLocales }
          failed={ this.props.failed }
          running={ this.props.running }
          success={ this.props.success }
          error={ this.props.error }
        />
      </div>
    )
  }
}

AddUser.propTypes = {
  addUser: PropTypes.func.isRequired,
  userRoles: PropTypes.array.isRequired,
  userLocales: PropTypes.array.isRequired,
  loadUserRoles: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  
  const mapping = {

    running: DckSelectors.selectProcessRunning(
      state,
      ProcessTypes.USERS_ADD
    ),

    failed: DckSelectors.selectProcessFailed(
      state,
      ProcessTypes.USERS_ADD
    ),

    success: DckSelectors.selectProcessSuccess(
      state,
      ProcessTypes.USERS_ADD
    ),
  
    userRoles: DckSelectors.selectAllItems(state, ItemTypes.UserRole),

    userLocales: DckSelectors.selectAllItems(state, ItemTypes.UserLocale),

    resultProcess: DckSelectors.selectProcess(state, ProcessTypes.USERS_ADD)
  }

  mapping['error'] = mapping.failed && mapping.resultProcess && mapping.resultProcess.result ? mapping.resultProcess.result.message : ''

  return mapping
}

const mapDispatchToProps = dispatch => ({
  addUser: data => dispatch(DckActionCreators.itemAdd(ItemTypes.User, data)),
  loadUserRoles: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.UserRole))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddUser)



// WEBPACK FOOTER //
// ./src/components/Users/AddUser/index.js